import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import styled from 'styled-components'
import { Breadcrumb } from '../components/Breadcrumb'
import PageHeader from '../components/PageHeader'
import LinkList from '../components/LinkList'
import Layout from '../components/Layout'
import VejaTambem from '../components/VejaTambem'

const Container = styled.section`
  width: 100%;
`

export const LinksTemplate = ({ title, content, slug, image, color, area }) => {
  const crumbs = [
    { id: 1, link: '/', title: 'Home', icon: true },
    { id: 2, link: '/', title: area, icon: true },
    {
      id: 3,
      link: slug,
      title,
    },
  ]
  return (
    <>
      <Container>
        <Breadcrumb crumbs={crumbs} />

        <PageHeader
          title={title}
          content={content}
          image={image}
          color={color}
          txtColor="cinza"
          height="207px"
          bottom="0px"
          overflow="visible"
          imgWidth="43%"
        />
      </Container>
    </>
  )
}

LinksTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
}

const Links = ({ data, location }) => {
  const { siteMetadata: site } = data.site
  const { wpPage: page } = data
  const image = page.opEsDaPGina.imagem ? page.opEsDaPGina.imagem.sourceUrl : ''
  const area = location.state ? location.state.area : page.opEsDaPGina.area
  const { paginasRelacionadas } = page.opEsDaPGina
  const { linksGerais } = page.LinksGerais
  const description = page.excerpt
    ? page.excerpt.replace(/<\/?[^>]+(>|$)/g, '').replace(/\n/g, '')
    : ''

  return (
    <Layout title={`${page.title} – ${site.title}`} description={description}>
      <LinksTemplate
        title={page.title}
        content={page.content}
        image={image}
        slug={page.slug}
        color={page.opEsDaPGina.corDoCabecalho}
        area={area}
      />

      <LinkList links={linksGerais} title="Documentos para download" />
      <VejaTambem relatedPages={paginasRelacionadas} />
    </Layout>
  )
}

Links.propTypes = {
  data: PropTypes.object.isRequired,
}

export default Links

export const LinksQuery = graphql`
  query LinksById($id: String!) {
    site {
      siteMetadata {
        url
        title
      }
    }
    wpPage(id: { eq: $id }) {
      title
      content
      slug
      excerpt
      LinksGerais {
        linksGerais {
          url
          tituloLink
          descricao
        }
      }
      opEsDaPGina {
        corDoCabecalho
        area
        imagem {
          sourceUrl
        }
        paginasRelacionadas {
          ... on WpPage {
            id
            title
            slug
          }
        }
      }
    }
  }
`
